import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import MenuUfficiItems from './MenuUfficiItems';
import MeetingRoom from '../../GoogleIcons/Outlined/MeetingRoom';
import NavigateNextIcon from '../../GoogleIcons/Outlined/NavigateNextIcon';
import NavDropdown from '../../NavDropdown';

const MenuUffici = ({
  uffici, ufficioSelezionato, onUfficioChange,
}) => {
  const ufficiOrdered = useMemo(() => (uffici || []).sort((a, b) => a - b), [uffici]);

  return ufficiOrdered.length > 3
    ? (
      <NavDropdown.SubMenu
        title={(
          <Button className="v2-menu-utente__uffici-btn">
            <MeetingRoom /> Cambia ufficio <NavigateNextIcon />
          </Button>
        )}
      >
        <MenuUfficiItems
          uffici={ufficiOrdered}
          ufficioSelezionato={ufficioSelezionato}
          onUfficioChange={onUfficioChange}
        />
      </NavDropdown.SubMenu>
    )
    : (
      <MenuUfficiItems
        uffici={ufficiOrdered}
        ufficioSelezionato={ufficioSelezionato}
        onUfficioChange={onUfficioChange}
      />
    );
};

MenuUffici.propTypes = {
  uffici: PropTypes.arrayOf(PropTypes.string),
  ufficioSelezionato: PropTypes.string,
  onUfficioChange: PropTypes.func.isRequired,
};

MenuUffici.defaultProps = {
  uffici: [],
  ufficioSelezionato: null,
};

export default MenuUffici;
